import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import {
  createDepositFormSchema,
  getDepositValidationConfig,
} from '@/shared/lib/index.ts';
import type { DepositFormValues } from '@/shared/types';

interface UseDepositFormOptions {
  operationType: string;
  minAmount?: number;
  maxAmount?: number;
  currencyCode?: string;
  initialData?: DepositFormValues | null;
}

export const useDepositForm = ({
  operationType,
  minAmount,
  maxAmount,
  currencyCode,
  initialData,
}: UseDepositFormOptions) => {
  const { t } = useTranslation();

  const validationConfig = getDepositValidationConfig(operationType);

  const schema = useMemo(
    () =>
      createDepositFormSchema(
        t,
        validationConfig,
        minAmount,
        currencyCode,
        maxAmount
      ),
    [t, validationConfig, minAmount, currencyCode, maxAmount]
  );

  const form = useForm<DepositFormValues>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues: {
      currencyCode: initialData?.currencyCode || '',
      amount: String(initialData?.amount),
    },
  });

  return {
    form,
  };
};
